import { gql } from "@apollo/client";

export const CREATE_GROUP = gql`
  mutation CreateGroup($input: GroupInput) {
    createGroup(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const GET_GROUP_PAGINATION = gql`
  query GetGroupPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $isUse: Boolean
  ) {
    getGroupPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      isUse: $isUse
    ) {
      data {
        _id
        groupKhName
        groupEnName
        isUse
        sortOrder
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const SELECT_GROUP = gql`
  query SelectGroup($isUse: Boolean) {
    selectGroup(isUse: $isUse) {
      _id
      groupKhName
      groupEnName
    }
  }
`;

export const UPDATE_GROUP_IS_USE = gql`
  mutation UpdateGroupIsUse($id: ID!, $isUse: Boolean) {
    updateGroupIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation UpdateGroup($id: ID!, $input: GroupInput) {
    updateGroup(_id: $id, input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;
export const UPDATE_GROUP_SORT_ORDER = gql`
  mutation UpdateGroupSortOrder($id: ID!, $input: GroupInput) {
    updateGroupSortOrder(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_GROUP = gql`
  mutation DeleteGroup($id: ID!) {
    deleteGroup(_id: $id) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;
